import React from 'react'
import SignUpField from './SignUpField'
import Scroll from 'react-scroll'
import img from '../../../public/mm-logo.png'
import socialConstants from '../../constants/social'
import fb from '../../../public/images/icons/facebook.svg'
import instagram from '../../../public/images/icons/insta.svg'
import linkedIn from '../../../public/images/icons/linkedin.svg'
import twitter from '../../../public/images/icons/twitter.svg'

const socialIconMap = {
  facebook: fb,
  instagram: instagram,
  linkedIn: linkedIn,
  twitter: twitter
}

const Footer = () => {
  const socialIcons = socialConstants.map((social) => {
    const { name, iconName, link } = social
    return (
            <a key={name} href={ link } target="_blank">
              <img src={socialIconMap[name]} alt={iconName} />
            </a>
    )
  })
  
    return (
      <div className='footer'>
        <div className="grid grid--gutters grid--full large-Grid--fit u-textCenter logo-flex">
          <div className="grid-cell" style={{paddingBottom: '18px', paddingTop: 0}}>
            <div className="logo-cell" onClick={()=> Scroll.animateScroll.scrollToTop()}>
            {<img className='footer-logo' src={img} alt='Mind Makers'/>}
            <p className='small-text' style={{paddingTop: '8px'}}>©  Copyright Mind Makers, Inc.</p>
            </div>
          </div>
          <div className="grid-cell" style={{paddingTop: '6px', textAlign: 'left'}}>
            <div className="signup-cell">
              <p className='bold-text'>Mailing List</p>
              <p className='small-text' style={{fontWeight: 200}}>Sign up to stay up to date with all the things our minds are making!</p>
              <SignUpField />
            </div>
          </div>
          <div className="grid-cell" style={{paddingTop: '25px', textAlign: 'left'}}>
            <div className="social-cell">
              <p className='bold-text' style={{paddingBottom: '15px'}}>Follow Us</p>
              {socialIcons}
            </div>
          </div>
        </div>
      </div>
    )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js